import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as OnboardingInformPatient } from 'assets/OnboardingInformPatient.svg';
import Theme from 'theme';

function InformPatientCareStep() {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' mb={4.5}>
      <Box sx={{ width: '100%', mb: 4.5 }}>
        <OnboardingInformPatient width='90%' height='90%' />
      </Box>
      <Typography variant='h6' fontWeight={500} sx={{ mb: 2 }} color={Theme.custom.colors.lightTextPrimary}>
        Inform patient care
      </Typography>
      <Typography sx={{ fontSize: 16, color: Theme.custom.colors.lightTextPrimary, textAlign: 'center', maxWidth: '90%' }}>
        As patients use the app, you&apos;ll see your patient’s behaviors (like sleep
        <br />
        and mood logs) over time so you can
        {' '}
        <b>
          spot trends quickly
        </b>
        {' '}
        and
        {' '}
        <b>
          improve patient care.
        </b>
      </Typography>
    </Box>
  );
}

export default InformPatientCareStep;
